import Articles from './Articles';

export const articlesRoutes = [{path: '/articles', name: 'Articles', Component: Articles}];
